import styled from 'styled-components';

export const StyledTradeInIcon = styled.svg`
    display: block;
`;
